<template>
    <div id="seccion-principal-LAUD">
        <div id="encabezados-tp">
            <h1>Lista de audiencias</h1>
            <h3>visualiza el lsiatdo de audiencias por fecha</h3>
        </div>
        <div class="filtros-busqueda margen-main-GT">
            <h6>Fecha de audiencia:</h6>
            <input class="form-control col-2" @change="ejecutarProcesoGetAudiencias({ conLoading: true, limpiarListaEdicion: true })" v-model="audiencias.filtros.fecha" type="date">
            <button v-tooltip:right="'Actualizar tabla desde base de datos'" @click="ejecutarProcesoGetAudiencias({ conLoading: true })" type="button" class="btn btn-sm btn-dark"><i class="fas fa-sync"></i></button>
        </div>
        <div class="tabla-audiencias-VLAUD margen-main-GT">
            <div id="toolbar-tabla-lista-PA">
                <div class="form-inline flex-wrap" style="gap: 2em !important;">
                    <div class="pl-0 pr-0">
                       <!--  <CCatalogoGenerico class="p-0 m-0" 
                            v-on:valorParaElPadre="evtCambioTipoPartido" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="FILTROS_BUSQUEDA.CPartidoJudicial.ID" 
                            :valorDefinido="FILTROS_BUSQUEDA.CPartidoJudicial.valorDefinido"
                            :textoOpcionesSingular="''"
                            :textoOpcionesPlural="''"
                            :elementosCatalogo="FILTROS_BUSQUEDA.CPartidoJudicial.opciones"
                            :conOpcionDeinstrucciones="FILTROS_BUSQUEDA.CPartidoJudicial.mostrarSoloOpcionesValidas"
                            :key="FILTROS_BUSQUEDA.CPartidoJudicial.KEY + FILTROS_BUSQUEDA.CPartidoJudicial.contRender"></CCatalogoGenerico> -->
                         <div class="form-inline flex-wrap newSectionFilters" style="gap: 0.5em !important;">
                                    <multiselect
                                        style="width: 420px !important;"
                                        v-model="FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas" 
                                        tag-placeholder="Agregar como nuevo partido" 
                                        placeholder="Buscar partido" 
                                        label="valor" 
                                        track-by="llave" 
                                        :options="FILTROS_BUSQUEDA.CPartidoJudicial.opciones" 
                                        :multiple="true" 
                                        :taggable="true" 
                                        @select="evtAgregarPartidoFiltros"
                                        @remove="evtRemoverPartidoFiltros"></multiselect> 
                                    <button type="button" class="btn btn-light" 
                                        @click="evtMostrarTodosLosPartidos" 
                                        v-tooltip:right="'Mostrar por todos los partidos'"><i class="fas fa-trash"></i>
                                    </button>   
                            </div>
                    </div>
                    <button v-if="campoEsValido({ campoAValidar: listaConFiltros })" @click="ejecutarProcesoGetExcelListaDeAudiencias({ conLoading: true })" type="button" class="btn btn-success">
                        <i class="fas fa-file-excel"></i>&nbsp;&nbsp;Descargar excel
                    </button>
                </div>
            </div>
            <table
                class="table table-light table-hover"
                :id="audiencias.TABLA.ID"              
                data-toggle="table"
                data-pagination="true"
                data-undefined-text="-" 
                data-toolbar="#toolbar-tabla-lista-PA"
                data-maintain-meta-data="true"
                data-click-to-select="false"
                data-page-size = "1000"
                data-page-list="[10,20,30, 40, 50, 60, 70, 80, 90, 100]"
                data-show-toggle="true"
                data-show-pagination-switch="true"
                data-row-style="aplicarEstilosPorPartidoJudicial"
                data-search="true">
                <thead class="thead-dark">
                    <tr>
                        <th data-halign="center" data-width="10" data-align="center" data-field="partidoJudicial" data-sortable="true">
                            PARTIDO
                        </th>
                        <th data-halign="center" data-width="38" data-align="center" data-field="carpeta" data-sortable="true">
                            CARPETA
                        </th>
                        <th data-halign="center" data-width="15" data-align="center" data-field="hora" data-sortable="true">
                            HORA
                        </th>
                        <th data-halign="center" data-width="6" data-align="center" data-field="juez" data-sortable="true">
                            JUEZ
                        </th>
                        <th data-halign="center" data-width="6" data-align="center" data-field="auxiliar" data-sortable="true">
                            AUXILIAR
                        </th>
                        <th data-halign="center" data-width="6" data-align="center" data-field="sala" data-sortable="true">
                            SALA
                        </th>
                        <th data-halign="center" data-width="6" data-align="center" data-field="zoom" data-sortable="true">
                            ID ZOOM
                        </th>
                        <th data-halign="center" data-width="10" data-align="center" data-field="audiencia" data-sortable="true">
                            AUDIENCIA
                        </th>
                        <th data-halign="center" data-width="10" data-align="center" data-field="estado" data-sortable="true">
                            ESTADO
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
    </div>
</template>
<script>
import { campoEsValido } from "../../SINOJ/Comun/Funciones/validaciones.js"
import { inicializarTabla, actualizarFilas, insertarFilas, eliminarFilas } from "../Programacion/Funciones/Tablas.js"
import { servicioRestPost } from '../Programacion/servicios/ServiciosHttp.js'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api';
import moment from 'moment'
import sistemas from '@/../static/js/sistemas'
import {CATALOGOS} from '../Catalogos/CatalogosBD.js'
import enumeraciones from '@/../static/js/enumeraciones'
import Multiselect from 'vue-multiselect'

export default {
    components: {
        CCatalogoGenerico: sistemas.SINOJ.CCatalogoGenerico,
        Multiselect
    },
    data() {
        return {
            CATALOGOS,
            enumeraciones,
            campoEsValido,
            audiencias: {
                filtros: {
                    fecha: moment().format('YYYY-MM-DD'),
                },
                TABLA: {
                    ID: 'ID-TablaAudinciasProgramadas-VLAUD',
                    lista: []
                }
            },
            FILTROS_BUSQUEDA: {
                CPartidoJudicial: {
                    ID: 'CTipoPartidoJudicial_VGREGAUD',
                    KEY: 'KEY_CTipoPartidoJudicial_VGREGAUD',
                    valorDefinido: -1,
                    opciones: CATALOGOS.partidoJudicial,
                    mostrarSoloOpcionesValidas: false,
                    contRender: 0,
                    opcionesSeleccionadas: []
                },
            },
            listaConFiltros: []
        }
    },
    watch: {  
      'FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas': async function() { debugger
            await Promise.resolve(this.filtradoMultiplePartidosJudiciales({ lista: this.audiencias.TABLA.lista }));
        }    
    },
    methods: {
        evtMostrarTodosLosPartidos: async function() {
            this.FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas = [];
            //await Promise.resolve(this.filtradoMultiplePartidosJudiciales());
        },
        evtRemoverPartidoFiltros: async function(partidoObj) {
            //await Promise.resolve(this.filtradoMultiplePartidosJudiciales());
        },
        evtAgregarPartidoFiltros: async function(partidoObj) {
            //await Promise.resolve(this.filtradoMultiplePartidosJudiciales());
        },
        filtradoMultiplePartidosJudiciales: async function({ lista }) { debugger
            let mostrarPorTodos = this.FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas.length < 1;
            if(mostrarPorTodos) {
                await Promise.resolve(inicializarTabla({ idReferencia: this.audiencias.TABLA.ID, elementos: lista, callbackCheck: () => {}, callbackPaginacion: () => {} }));
            }
            else {
                //console.log('this.programaciones.FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas::',this.FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas);
                await Promise.resolve(inicializarTabla(
                    { idReferencia: this.audiencias.TABLA.ID, 
                        elementos: lista.filter(p => this.FILTROS_BUSQUEDA.CPartidoJudicial.opcionesSeleccionadas.some(opSel => opSel.llave == p.partidoJudicial)), 
                        callbackCheck: () => {}, 
                        callbackPaginacion: () => {} 
                    }));
            }
        },
        getPeticionGeneracionDeExcel: function() {
            let peticion = new FormData();
            let audiencias = this.listaConFiltros.map(a => {
                let aObj = {};
                aObj.Partido = `${ a.partidoJudicial }`;
                aObj.Carpeta = `${ a.carpeta }`;
                aObj.Hora = `${ a.hora }`;
                aObj.Juez = `${ a.juez }`;
                aObj.Auxiliar = `${ a.auxiliar }`;
                aObj.Sala = `${ a.sala }`;
                aObj.IdZoom = `${ a.zoom }`;
                aObj.Audiencia = `${ a.audiencia }`;
                aObj.Estado = `${ a.estado }`;
                return aObj;
            });
            peticion.append('EsPrueba',false); 
            peticion.append('fechaAudiencia',this.audiencias.filtros.fecha); 
            peticion.append('ListaDeAudiencias',JSON.stringify(audiencias)); 
            return peticion;
        },
        descargarArchivoExcel: function({ arrayBuffer }) {
            let a = document.createElement('a');
            a.href = URL.createObjectURL(new Blob(
                [ arrayBuffer ],
                { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
            ));
            a.download =  `${ this.audiencias.filtros.fecha }-ListaDeAudiencias.xlsx`;
            a.click()
        },
        ejecutarProcesoGetExcelListaDeAudiencias: async function({ conLoading }) {
            if(conLoading)
                comun.SeEstaCargandoInformacion(true);
            try {
                const PETICION_GET_AUDIENCIAS_EXCEL = this.getPeticionGeneracionDeExcel();
                const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.GestionAudiencias.sistema.programacionAudiencias.programacion.ObtenerExcelListaAudiencias,
                    peticionServicio: PETICION_GET_AUDIENCIAS_EXCEL,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: true }
                }));

                if(!CON_ERROR && RESPUESTA.byteLength > 0) {
                    this.descargarArchivoExcel({ arrayBuffer: RESPUESTA });
                }
                else {
                   comun.mensajeDeAlerta('Ocurrio un error al exportar la infromacion a excel');
                }

                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(e) {
                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
                console.error(e);
            }
        },
        evtCambioTipoPartido: async function(evento) {
            this.FILTROS_BUSQUEDA.CPartidoJudicial.valorDefinido = parseInt(evento.target.value);
            if(this.FILTROS_BUSQUEDA.CPartidoJudicial.valorDefinido < 1) {
                this.listaConFiltros = this.audiencias.TABLA.lista;
                await Promise.resolve(inicializarTabla({ idReferencia: this.audiencias.TABLA.ID, elementos: this.listaConFiltros }));
            }
            else {
                this.listaConFiltros = this.audiencias.TABLA.lista.filter(p => p.partidoJudicial == this.FILTROS_BUSQUEDA.CPartidoJudicial.valorDefinido);
                await Promise.resolve(inicializarTabla({ idReferencia: this.audiencias.TABLA.ID, elementos: this.listaConFiltros }));
            }
        },
        ejecutarProcesoGetAudiencias: async function({ conLoading }) {
            if(conLoading)
                comun.SeEstaCargandoInformacion(true);
            try {
                const PETICION_GET_AUDIENCIAS = { EsPrueba: false, FechaAudiencia: this.audiencias.filtros.fecha, conCocluidas: true }
                const { CON_ERROR, RESPUESTA: { AudienciasProgramadas } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.GestionAudiencias.sistema.programacionAudiencias.programacion.ObtenerAudienciasProgramadas,
                    peticionServicio: PETICION_GET_AUDIENCIAS,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));

                if(!CON_ERROR) {
                    this.audiencias.TABLA.lista = campoEsValido({ campoAValidar: AudienciasProgramadas }) 
                    ? AudienciasProgramadas.map(a => {
                        let audienciaObj = { ...a };
                        let carpetaCompleta = CATALOGOS.tiposCarpetas.find(tc => tc.llave == a.tipoCarpeta);
                        audienciaObj.carpeta = campoEsValido({ campoAValidar: carpetaCompleta }) ? `${ carpetaCompleta.valor }${ a.carpeta }` : a.carpeta;
                        audienciaObj.hora =  (a.fechaAudiencia != null) ? moment(a.fechaAudiencia).format('hh:mm A') : '-';
                        audienciaObj.juez = campoEsValido({ campoAValidar: a.juez }) ? a.juez.toUpperCase() : a.juez;
                        audienciaObj.auxiliar = campoEsValido({ campoAValidar: a.auxiliar }) ? a.auxiliar.toUpperCase() : a.auxiliar;
                        audienciaObj.partido = `${ a.partidoJudicial }`;
                        audienciaObj.sala = `${ campoEsValido({ campoAValidar: a.sala }) ? a.sala : '-' } ${ campoEsValido({ campoAValidar: a.modo }) ? ('- ' + a.modo) : '' }`;
                        return audienciaObj;
                    })
                    : [];
                    await Promise.resolve(inicializarTabla({ idReferencia: this.audiencias.TABLA.ID, elementos: this.audiencias.TABLA.lista }));
                    this.FILTROS_BUSQUEDA.CPartidoJudicial.valorDefinido = -1;
                    this.FILTROS_BUSQUEDA.CPartidoJudicial.contRender ++;
                    this.listaConFiltros = this.audiencias.TABLA.lista;

                    await Promise.resolve(this.filtradoMultiplePartidosJudiciales({ lista: this.audiencias.TABLA.lista }));
                }

                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(e) {
                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
                console.error(e);
            }
        },
        getNombreJuez: function(nombreCompleto) {
            let nombre = null;
            try {
                if(campoEsValido({ campoAValidar: nombreCompleto })) {
                    let nombreArray = nombreCompleto.split(' ');
                    let numeroDeNombres = nombreArray.length;
                    let indexNombre = numeroDeNombres > 1 ? 1 : 0;
                    nombre = nombreArray[indexNombre];
                }
            }
            catch(error) {
                throw error;
            }
            return nombre;
        }
    },
    async mounted() {
        await Promise.resolve(this.ejecutarProcesoGetAudiencias({ conLoading: true }));
    }
}
</script>
<style scoped>
.margen-main-GT {
    padding: 0 3em 0 2em;
}

/* ========== TITULOS ============== */
#encabezados-tp {
    margin-bottom: 4em;
    width: 100%;
    text-align: center;
    background-color: rgb(20, 20, 20);
    padding: 1em 0 0.5em 0;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 2.5em;
}

#encabezados-tp h3 {
    font-size: 1.5em;
    color: rgb(175, 175, 175);
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#ffffff;
}

/* ========== SECCIONES ============== */
.filtros-busqueda {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1em;
    flex-wrap: wrap;
    margin-bottom: 2em;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
@media (max-width: 1240px) {
    .tabla-audiencias-VLAUD td, .tabla-audiencias-VLAUD th {
        font-size: 0.77em !important;
    }
}

.tabla-audiencias-VLAUD {
    padding-bottom: 2em;
    padding-right: 1em;
}

.tabla-audiencias-VLAUD .btn-sm {
    font-size: .9em !important;
}


.tabla-audiencias-VLAUD .newSectionFilters .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #42505c;
    font-size: 1em;
}

.tabla-audiencias-VLAUD .btn-secondary {
    width: 2.5rem;
    background-color: #1f1f21;
    color: white;
    padding: 0.3em 0.3em 0.3em 0.3em;
    box-shadow: none;
}

.tabla-audiencias-VLAUD .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 40vmin;
}

.tabla-audiencias-VLAUD .inputs-sm-edicion-VPA {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    width: 6.7em;
    font-size: 1em;
}

.tabla-audiencias-VLAUD .inputs-xs-edicion-VPA {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    width: 5.5em;
    font-size: 1em;
}

.tabla-audiencias-VLAUD .inputs-md-edicion-VPA {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    width: 10em;
    font-size: 1em;
}

.tabla-audiencias-VLAUD .inputs-lg-edicion-VPA {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    width: 14em;
    font-size: 1em;
}

.tabla-audiencias-VLAUD .borderless td, .tabla-audiencias-VLAUD .borderless th {
    border: none;
    border-bottom: 1px solid #d8d7d7 !important;
}

.tabla-audiencias-VLAUD td {
    border: none !important;
    font-size: 1.5em !important;
}

.tabla-audiencias-VLAUD th {
    font-size: 1.5em !important;
}

.tabla-audiencias-VLAUD .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #AF9C9C;
    font-size: 1em;
}

.tabla-audiencias-VLAUD .dropdown-toggle {
    width: 3.3rem;
    background-color: #1f1f21;
    color: white;
}

.tabla-audiencias-VLAUD .pagination > li > a {
    background-color: white;
    color: #121213;
}

.tabla-audiencias-VLAUD .pagination > .active > a {
    color: white;
    background-color:  #1f1f21;
    border: solid 1px #676666;
}

.tabla-audiencias-VLAUD > .active > a:hover {
    background-color:  #21211f;
    border: solid 1px #676666;
} 

</style>


// WEBPACK FOOTER //
// src/components/Audiencias/ListaAudiencias/CListaDeAudiencias.vue